import axios from 'axios'

export const AgreementApi = {
    async Table(data){
        const response = await axios.post('/api/agreementoperations/table',data)
        return response
    },
    async Create(data){
        const response = await axios.post('/api/agreementoperations/create' , data)
        return response
    },
    async Detail(data){
        const response = await axios.get(`/api/agreementoperations/detail/${data}`)
        return response
    },
    async DailyRouteCheckRuns(data){
        const response = await axios.post('/api/agreementoperations/dailyroutecheck/runs',data)
        return response
    },
    async DailyRouteCheckRunDetail(id){
        const response = await axios.get(`/api/agreementoperations/dailyroutecheck/runs/${id}`)
        return response
    },
    // Yakıt kaynaklı fiyat güncellemesinin bildirim içeriği: ekip özeti ve nakliyeci mailleri.
    async FuelUpdateNotificationSummary(runId){
        const response = await axios.get(`/api/agreementoperations/dailyroutecheck/notification/summary/${runId}`)
        return response
    },
    async PreviewTeamFuelUpdateNotification(runId){
        const response = await axios.get(`/api/agreementoperations/dailyroutecheck/notification/preview/team/${runId}`)
        return response
    },
    async PreviewCarrierFuelUpdateNotification(agreementLogId){
        const response = await axios.get(`/api/agreementoperations/dailyroutecheck/notification/preview/carrier/${agreementLogId}`)
        return response
    },
    async SendCarrierFuelUpdateNotifications(data){
        const response = await axios.post('/api/agreementoperations/dailyroutecheck/notification/carrier/send',data)
        return response
    },
    async DownloadCarrierPriceList(agreementLogId){
        const response = await axios.get(`/api/agreementoperations/dailyroutecheck/notification/carrier/pricelist/${agreementLogId}`,{responseType:'blob'})
        return response
    },
    async Delete(data){
        const response = await axios.post(`/api/agreementoperations/delete/${data}`)
        return response
    },
    async AddRoute(data){
        const response = await axios.post(`/api/agreementoperations/add/route`,data)
        return response
    },
    // Rota kaydedilmeden önce baz tarihten bugüne oluşacak ara zamların önizlemesi.
    async SimulateRoute(data){
        const response = await axios.post(`/api/agreementoperations/route/simulate`,data)
        return response
    },
    // Toplu önizleme: sözleşme oluşturma ve Excel yüklemesinde tüm rotalar için.
    async SimulateRoutes(data){
        const response = await axios.post(`/api/agreementoperations/routes/simulate`,data)
        return response
    },
    async DeleteRoute(data){
        const response = await axios.post(`/api/agreementoperations/delete/route/${data}`)
        return response
    },
    // Toplu rota silme. IncludeHistory true ise rotanın tüm fiyat versiyonları kaldırılır.
    async DeleteRoutes(data){
        const response = await axios.post('/api/agreementoperations/delete/routes',data)
        return response
    },
    async Download(data){
        const response = await axios.post(`/api/agreementoperations/download/document/${data}`)
        return response
    },
    async UpdateInflationRate(data){
        const response = await axios.post('/api/agreementoperations/update/inflation',data)
        return response
    },
    async UpdateExpireDate(data){
        const response = await axios.post('/api/agreementoperations/update/expiredate',data)
        return response
    },
    // Cari seçilmeden kaydedilmiş sözleşmenin carisini bağlar. Yalnızca cari alanı boş olan
    // sözleşmelerde çalışır; dolu cariyi değiştirme sunucu tarafında reddedilir.
    async UpdateCari(data){
        const response = await axios.post('/api/agreementoperations/update/cari',data)
        return response
    },
    async UpdateRoutePrice(data){
        const response = await axios.post('/api/agreementoperations/update/routeprice',data)
        return response
    },
    // Toplu fiyat düzenleme şablonu: mevcut fiyatların yanında boş "Yeni Fiyat" ve
    // "Değişiklik Türü" kolonlarını taşıyan, "Rota Fiyatlar" çıktısından ayrı bir dosya.
    async DownloadRoutePriceTemplate(agreementId){
        const response = await axios.get(`/api/agreementoperations/routes/pricetemplate/${agreementId}`,{responseType:'blob'})
        return response
    },
    // Doldurulmuş şablonu okur. Hiçbir fiyat kaydedilmez, sadece ekrana yansıtılır.
    async ReadRoutePriceTemplate(data){
        const response = await axios.post('/api/agreementoperations/routes/pricetemplate/read',data)
        return response
    },
    // Toplu manuel fiyat düzenleme: bir satır hata verirse hiçbiri kaydedilmez.
    async UpdateRoutePrices(data){
        const response = await axios.post('/api/agreementoperations/update/routeprices',data)
        return response
    },
    // Mevcut sözleşmeye toplu rota ekleme.
    async AddRoutes(data){
        const response = await axios.post('/api/agreementoperations/add/routes',data)
        return response
    },
    async UploadExcel(data){
        const response = await axios.post(`/api/agreementoperations/excelupload`,data)
        return response
    },
    async DownloadSampleFile(){
        const response = await axios.get(`/api/agreementoperations/downloadsamplefile`,{
            responseType: 'blob',
        })
        return response
    },
    async DownloadRoutes(id){
        const response = await axios.get(`/api/agreementoperations/download/agreementroutes/${id}`,{
            responseType: 'blob',
        })
        return response
    },
    // Sözleşme belgesini yeni sürüm olarak yükler. Değişiklik notu zorunludur;
    // önceki sürüm silinmez, geçmişe taşınır.
    async UploadAgreementDocument(data){
        const response = await axios.post('/api/agreementoperations/upload/agreementdocument',data)
        return response
    },
    // Sözleşme belgesinin tüm sürümleri, en yeniden eskiye.
    async DocumentHistory(agreementId){
        const response = await axios.get(`/api/agreementoperations/document/history/${agreementId}`)
        return response
    },
    async PriceChangeHistory(id){
        const response = await axios.get(`/api/agreementoperations/get/agreementroutepricechangehistory/${id}`)
        return response
    },
    async PriceChangeHistoryExcel(id){
        const response = await axios.get(`/api/agreementoperations/download/agreementroutepricechangehistory/${id}`,{
            responseType: 'blob',
        })
        return response
    },
    async CalculatePrices(data){
        const response = await axios.post(`/api/agreementoperations/calculate/prices`,data)
        return response
    },
    async UpdatePrices(data){
        const response = await axios.post(`/api/agreementoperations/update/prices`,data)
        return response
    },
    async RouteAnalysis(data){
        const response = await axios.post('/api/agreementoperations/analysis/routes',data)
        return response
    },
    async RouteInsights(data){
        const response = await axios.post('/api/agreementoperations/analysis/insights',data)
        return response
    },
    async RouteAdvancedAnalysis(data){
        const response = await axios.post('/api/agreementoperations/analysis/advanced',data)
        return response
    },
    async RouteAnalysisExcel(data){
        const response = await axios.post('/api/agreementoperations/analysis/excel',data,{
            responseType: 'blob',
        })
        return response
    },
    async RouteAnalysisLegend(){
        const response = await axios.get('/api/agreementoperations/analysis/legend')
        return response
    },
    async RouteAnalysisFilters(){
        const response = await axios.get('/api/agreementoperations/analysis/filters')
        return response
    },
    Out:{
        async Create(data){
            const response = await axios.post('/api/agreementoperations/create/out' , data)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/agreementoperations/table/out' , data)
            return response
        },
    }
}
